import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        projectId:  Number,
        estimateId: Number,
        category:   String
    }

    static targets = ["panel"]

    connect() {
        this._setupMoveForm()
    }

    // ———————— MOVE‑SELECTED INJECTION ————————
    _setupMoveForm() {
        this.moveForm = this.element.querySelector(`#move_form_${this.estimateIdValue}`)
        if (!this.moveForm) return
        this.boundInjectSelectedIds = this._injectSelectedIds.bind(this)
        this.moveForm.addEventListener("submit", this.boundInjectSelectedIds)
    }

    disconnect() {
        if (!this.moveForm || !this.boundInjectSelectedIds) return
        this.moveForm.removeEventListener("submit", this.boundInjectSelectedIds)
        this.boundInjectSelectedIds = null
    }

    _injectSelectedIds(e) {
        // remove any old hidden inputs
        this.moveForm.querySelectorAll("input[name='selected_item_ids[]']").forEach(n => n.remove())

        // inject current checked IDs
        Array.from(this.element.querySelectorAll(".estimate_item_checkbox:checked")).forEach(cb => {
            const hidden = document.createElement("input")
            hidden.type  = "hidden"
            hidden.name  = "selected_item_ids[]"
            hidden.value = cb.dataset.estimateItemId
            this.moveForm.appendChild(hidden)
        })

        // block if none
        if (this.moveForm.querySelectorAll("input[name='selected_item_ids[]']").length === 0) {
            e.preventDefault()
            alert("Please select at least one item to move.")
        }
    }

    // ———————— LIVE PREVIEW ————————
    previewFields(event) {
        const field = event.currentTarget
        const val   = field.value
        const panel = this.panelTarget

        if (field.matches('.key_cat')) {
            panel.querySelectorAll('input.cat_input').forEach(i => i.value = val)
        } else if (field.matches('.key_labor')) {
            panel.querySelectorAll('input.labor_rate').forEach(i => i.value = val)
        } else if (field.matches('.key_markup')) {
            panel.querySelectorAll('input.markup_rate').forEach(i => i.value = val)
        }
    }

    // ————— CHANGE ACTIONS —————
    changeCategory(event) {
        event.preventDefault()
        const newVal = this.element.querySelector('.key_cat').value
        const items  = this._gatherIds('cat_input', /estimate_item_pricing_category_(\d+)/)

        this._post('update_pricing_category', {
            items:       items,
            oldCategory: this.categoryValue,
            varName:     'pricing_category',
            varValue:    newVal,
            categoryVal: newVal
        })

        this.element.querySelector('.key_cat').value = ''
        console.log('Updated category', newVal, items)
    }

    changeLabor(event) {
        event.preventDefault()
        const newVal = this.element.querySelector('.key_labor').value
        const items  = this._gatherIds('labor_rate', /estimate_item_labor_rate_(\d+)/)

        this._post('update_pricing_category', {
            items:       items,
            oldCategory: this.categoryValue,
            varName:     'labor_rate',
            varValue:    newVal,
            laborValue:  newVal
        })

        this.element.querySelector('.key_labor').value = ''
        console.log('Updated labor', newVal, items)
    }

    changeMarkup(event) {
        event.preventDefault()
        const newVal = this.element.querySelector('.key_markup').value
        const items  = this._gatherIds('markup_rate', /estimate_item_markup_rate_(\d+)/)

        this._post('update_pricing_category', {
            items:       items,
            oldCategory: this.categoryValue,
            varName:     'markup_rate',
            varValue:    newVal,
            markupValue: newVal
        })

        this.element.querySelector('.key_markup').value = ''
        console.log('Updated markup', newVal, items)
    }

    // ————— DUPLICATE / DELETE —————
    duplicateCategory(event) { event.preventDefault(); this._post('batch_duplicate_category',{ category: this.categoryValue }) }

    duplicateSelected(event) {
        event.preventDefault()
        const ids = this._checkedItemIds()
        if (!ids.length) return alert('No items selected')

        const attrs = {}
        ids.forEach(id => {
            const dup = document.getElementById(`estimate_item_duplicator_${id}`)
            attrs[id] = { duplicator: dup?.value||'1', selected: '1' }
        })

        this._post('duplicate_selected_estimate_items', {
            estimate_items:           ids,
            estimate_item_attributes: attrs
        })
    }

    deleteSelected(event) {
        event.preventDefault()
        const ids = this._checkedItemIds()
        if (!ids.length) return alert('No items selected')
        if (!confirm('Really delete the selected items?')) return
        this._post('batch_delete', { estimate_items: ids, checker: true })
    }

    deleteCategory(event) {
        event.preventDefault()
        if (!confirm(`Really delete category “${this.categoryValue}”?`)) return
        this._post('batch_delete_category', { category: this.categoryValue })
    }

    // ——————— HELPERS ———————
    _gatherIds(cssClass, regex) {
        return Array.from(this.element.querySelectorAll(`input.${cssClass}`))
            .map(input => {
                const m = input.id.match(regex)
                return { id: m ? Number(m[1]) : null }
            })
            .filter(obj => obj.id)
    }

    _checkedItemIds() {
        return Array.from(
            this.element.querySelectorAll('input.estimate_item_checkbox:checked')
        ).map(cb => Number(cb.dataset.estimateItemId))
    }

    _post(action, payload={}) {
        fetch(
            `/projects/${this.projectIdValue}/estimates/${this.estimateIdValue}/${action}`,
            { method:'POST', headers:{ 'Content-Type':'application/json','Accept':'text/vnd.turbo-stream.html','X-CSRF-Token':this._csrfToken() }, body:JSON.stringify(payload) }
        )
            .then(r=> r.ok ? r.text() : r.text().then(t=>Promise.reject(t)))
            .then(html=>{ if(html) Turbo.renderStreamMessage(html) })
            .catch(e=>console.error(e))
    }

    _csrfToken() {
        return document.querySelector('meta[name="csrf-token"]').content
    }
}
